"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetStrategyAttributes = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const graphql_1 = require("../../../../__generated__/graphql");
const attributes_utils_1 = require("./attributes.utils");
const client_constants_1 = require("../../client.constants");
const client_utils_1 = require("../../client.utils");
const hooks_1 = require("../../hooks");
const get_strategy_attributes_query_1 = require("../get-strategy-attributes.query");
const models_1 = require("../../../models");
// merge the new part with an already loaded
const updateQuery = (previousResult, options) => {
    var _a, _b;
    const { edges: prevAttributes = [] } = (_a = previousResult.productTreeNode.labelValidation) !== null && _a !== void 0 ? _a : {};
    const { productTreeNode } = (_b = options === null || options === void 0 ? void 0 : options.fetchMoreResult) !== null && _b !== void 0 ? _b : {};
    const _c = productTreeNode.labelValidation, { edges = [] } = _c, productStrategyLabelsData = __rest(_c, ["edges"]);
    return {
        productTreeNode: Object.assign(Object.assign(Object.assign({}, previousResult.productTreeNode), productTreeNode), { labelValidation: Object.assign(Object.assign({}, productStrategyLabelsData), { edges: [...prevAttributes, ...edges] }) }),
    };
};
const fetchMoreOptions = { updateQuery };
const useGetStrategyAttributes = ({ productTreeNodeId, sortingItem = models_1.SortingItem.SortByTextAsc, pageSize = client_constants_1.PAGE_SIZE_LARGE, options, filter, }) => {
    var _a, _b;
    const sort = attributes_utils_1.sortingItemToStrategyAttributesSortMap[sortingItem];
    const mergedFilter = (0, react_1.useMemo)(() => (filter ? (0, attributes_utils_1.getStrategyAttributesProductFilter)(filter) : undefined), [filter]);
    const { data, previousData, error, networkStatus, variables, fetchMore, refetch, } = (0, react_2.useQuery)(get_strategy_attributes_query_1.GET_STRATEGY_ATTRIBUTES, {
        notifyOnNetworkStatusChange: true,
        variables: {
            sort,
            productTreeNodeId: productTreeNodeId !== null && productTreeNodeId !== void 0 ? productTreeNodeId : '',
            filter: mergedFilter,
            first: pageSize,
            before: null,
            after: null,
            last: null,
        },
        skip: !productTreeNodeId || (options === null || options === void 0 ? void 0 : options.skip),
    });
    const { pageInfo, edges } = (_a = data === null || data === void 0 ? void 0 : data.productTreeNode.labelValidation) !== null && _a !== void 0 ? _a : {};
    const { hasNextPage } = pageInfo !== null && pageInfo !== void 0 ? pageInfo : {};
    const pagination = (0, hooks_1.usePagination)({
        networkStatus,
        pageInfo,
        pageSize,
        fetchMore,
        fetchMoreOptions,
        lastVariables: variables,
    });
    const onRefetch = (0, react_1.useCallback)((newVariables) => refetch(Object.assign(Object.assign(Object.assign({}, variables), newVariables), { first: pageSize, before: null, after: null, last: null })), [pageSize, variables, refetch]);
    const onSearch = (0, react_1.useCallback)((searchString) => onRefetch({
        filter: {
            some: {
                label: {
                    contains: searchString.trim(),
                    mode: graphql_1.StringFilterMode.Insensitive,
                },
            },
        },
    }), [onRefetch]);
    return {
        data: edges,
        previousData: (_b = previousData === null || previousData === void 0 ? void 0 : previousData.productTreeNode.labelValidation) === null || _b === void 0 ? void 0 : _b.edges,
        isLoading: (0, client_utils_1.isQueryLoadingOrRefetching)(networkStatus),
        isRefetching: (0, client_utils_1.isQueryRefetching)(networkStatus),
        pagination,
        error,
        hasNextPage,
        refetch: onRefetch,
        onSearch,
    };
};
exports.useGetStrategyAttributes = useGetStrategyAttributes;
